module.exports = __webpack_public_path__ + "static/img/box-open.86454e55.webp";